import styled from "styled-components";
import { colors } from "@/theme";
import { Box, Button, Dialog, DialogContent, DialogTitle, TextField } from "@mui/material";

export const ProductCartContainer = styled(Box)`
  width: 100%;
  height: calc(100% - 64px);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  position: fixed;
  top: 64px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
`;

export const ProductCartWrapper = styled(Box)`
  width: 97%;
  height: 95%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  border-radius: 24px;
  overflow: auto;
  background: transparent;
  position: relative;

  @media (min-width: 1200px) {
    flex-direction: row;
  }
`;

export const LeftColumn = styled(Box)`
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
  min-height: 70%;

  @media (min-width: 1200px) {
    min-height: 100%;
  }
`;

export const SearchContainer = styled(Box)`
  padding: 16px;
  background: #f5f6fa;
  border-radius: 16px;
  margin-bottom: 0;
  min-height: 48px;
  display: flex;
  align-items: center;
  box-shadow: none;
`;

export const StyledTextField = styled(TextField)`
  border: none;
  background: transparent;
  box-shadow: none;
  padding-left: 0;
  margin-bottom: 16px;
  border-radius: 8px;

  & .MuiInputBase-input::placeholder {
    color: ${colors.neutralGrey800};
    opacity: 1;
    font-size: 20px;
    font-family: "PF DIN Text Pro";
    line-height: 24px;
  }

  & .MuiInputBase-input {
    height: 40px;
    font-size: 20px;
    font-family: "PF DIN Text Pro";
    display: flex;
    font-weight: 400;
    align-items: center;
    padding: 0;
  }

  & .MuiInputBase-root {
    font-size: 18px;
    font-weight: 400;
    background: transparent;
    font-family: "PF DIN Text Pro";
  }
`;

export const CartContainer = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  padding: 16px;
  overflow: auto;

  & .MuiTableContainer-root {
    overflow-x: auto;
    &::-webkit-scrollbar {
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }
    &::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 4px;
    }
  }
`;

export const LoadingContainer = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 24px;
  font-weight: 500;
  font-family: "PF DIN Text Pro";
`;

export const EmptyCartContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 48px;
  margin-left: 16px;
`;

export const EmptyCartText = styled.span`
  color: ${colors.neutralGrey500};
  font-size: 20px;
  font-weight: 500;
`;

export const RightColumn = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;

  @media (min-width: 1200px) {
    min-height: auto;
  }
`;

export const UserInfoContainer = styled(Box)`
  padding: 16px;
  background: #f5f6fa;
  border-radius: 16px;
  min-height: 48px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: none;
`;

export const UserName = styled.div`
  font-weight: 500;
  font-family: "PF DIN Text Pro";
  font-size: 18px;
`;

export const UserDetails = styled.div`
  font-size: 14px;
  color: #888;
  font-family: "PF DIN Text Pro";
`;

export const PurchaseSummaryContainer = styled(Box)`
  font-family: "PF DIN Text Pro";
  flex: 1;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  padding: 24px;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

export const SummaryHeader = styled(Box)`
  font-weight: 600;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  font-size: 16px;
  border-bottom: 1px solid ${colors.neutralGrey400};
  padding-bottom: 5px;
  gap: 8px;

  @media (min-width: 600px) {
    flex-direction: row;
    align-items: center;
    gap: 0;
  }
`;

export const SummaryTitle = styled(Box)`
  font-weight: 500;
  font-size: 24px;
  color: ${colors.neutralGrey800};
`;

export const OrderNumber = styled(Box)`
  font-weight: 400;
  color: ${colors.neutralGrey600};
  font-size: 16px;
  font-family: "PF DIN Text Pro";
`;

export const SummaryDivider = styled.div`
  border-top: 1px solid ${colors.neutralGrey400};
  margin: 24px 0 12px 0;
`;

export const TotalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 18px;
  flex-direction: column;
  gap: 8px;

  @media (min-width: 600px) {
    flex-direction: row;
    gap: 0;
  }
`;

export const TotalLabel = styled(Box)`
  color: ${colors.neutralGrey800};
  font-size: 24px;
  font-weight: 500;
`;

export const TotalItems = styled(Box)`
  font-size: 16px;
  font-weight: 400;
`;

export const TotalAmount = styled(Box)`
  color: ${colors.primaryOzone500};
  font-weight: 500;
  font-size: 34px;
  line-height: 1;
`;

export const ButtonContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const StyledDialog = styled(Dialog)`
  & .MuiDialog-paper {
    border-radius: 24px;
    padding: 0;
    min-width: 350px;
    font-family: "PF DIN Text Pro";
  }
`;

export const StyledDialogTitle = styled(DialogTitle)`
  text-align: center;
  font-weight: 600;
  font-size: 18px;
  padding-top: 24px;
  padding-bottom: 8px;
  padding-left: 24px;
  padding-right: 24px;
  font-family: "PF DIN Text Pro" !important;
  & .MuiDialogTitle-root {
    font-family: "PF DIN Text Pro" !important;
  }
`;

export const StyledDialogContent = styled(DialogContent)`
  padding: 24px;
  padding-top: 8px;
  padding-bottom: 16px;
`;

export const DialogActionButton = styled(Button)`
  background: ${colors.primaryOzone500};
  color: ${colors.white};
  font-weight: 500;
  font-size: 18px;
  font-family: "PF DIN Text Pro";
  border-radius: 0 0 16px 16px;
  padding: 12px;
  box-shadow: none;
  text-transform: none;

  &:hover {
    background: #0059c1;
  }
`;

export const ProductCartIsEmptyMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding-top: 96px;
`;

export const ProductCartIsEmptyMessageHeader = styled.h1`
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
`;

export const ProductCartIsEmptyMessageBody = styled.h2`
  color: ${colors.black};
  font-family: "PF DIN Text Pro";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
`;

export const ButtonContinueToCheckoutContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

export const DiscountDialogContainer = styled.div`
  background: #fff;
  border-radius: 8px;
  box-sizing: border-box;
  width: 400px;
  max-width: 95vw;
  padding: 0;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 420px;
`;

export const DiscountDialogHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 24px 32px 0 32px;
  font-size: 22px;
  font-weight: 600;
  color: #222b45;
  font-family: 'PF DIN Text Pro';
`;

export const DiscountDialogDivider = styled.div`
  width: 100%;
  border-bottom: 1.5px solid #e5e7ef;
  margin-top: 18px;
`;

export const DiscountDialogContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 32px 0 32px;
  box-sizing: border-box;
`;

export const CloseCircleButton = styled.button`
  position: absolute;
  right: 24px;
  top: 16px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: ${colors.primaryOzone500};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,112,243,0.08);
  transition: background 0.2s;
  &:hover { background: #0059c1; }
`;

export const DiscountTabBar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 24px 0 0 0;
  border-bottom: 1px solid #e5e7ef;
`;

export const DiscountTab = styled.div<{active: boolean}>`
  font-size: 18px;
  font-weight: 600;
  color: ${({active}) => active ? '#222b45' : '#b0b4bb'};
  padding: 0 24px 12px 24px;
  cursor: pointer;
  border-bottom: ${({active}) => active ? '3px solid #0070f3' : '3px solid transparent'};
  transition: color 0.2s, border-bottom 0.2s;
`;

export const DiscountInputWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 32px 0 0 0;
`;

export const DiscountInput = styled(TextField)`
  width: 160px;
  & .MuiOutlinedInput-root {
    border-radius: 8px;
    background: #f5f6fa;
    font-size: 24px;
    font-weight: 500;
    color: #222b45;
    height: 56px;
    text-align: center;
    box-shadow: none;
    border: none;
    justify-content: center;
  }
  & .MuiOutlinedInput-notchedOutline {
    border-color: #e5e7ef !important;
  }
  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #e5e7ef !important;
  }
  & .MuiInputBase-input {
    text-align: center;
    font-size: 24px;
    font-weight: 500;
    color: #222b45;
    padding: 12px 0;
  }
  & .MuiInputAdornment-root {
    margin: 0 8px;
  }
`;

export const DiscountNoteTextarea = styled.textarea`  width: 100%;
  margin: 24px 0 0 0;
  min-height: 80px;
  border-radius: 8px;
  border: 1px solid #e5e7ef;
  background: #f5f6fa;
  font-size: 18px;
  font-family: 'PF DIN Text Pro';
  color: #b0b4bb;
  padding: 16px;
  resize: none;
  outline: none;
  transition: border 0.2s;
  box-sizing: border-box;
  &:focus {
    color: #222b45;
`;

export const AddDiscountButton = styled(Button)`
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
  background-color: ${colors.primaryOzone500};
  color: ${colors.white};
  font-size: 20px;
  font-weight: 600;
  border-radius: 0 0 16px 16px;
  padding: 22px 0 18px 0;
  text-transform: none;
  font-family: 'PF DIN Text Pro';
  box-shadow: none;
  border: none;
`;

